$(document).ready(function () {
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this)
                .parents(".js-href-teleport-wrapper")
                .find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : "_self";

        if (href) {
            $(this).wrapInner(
                '<a href="' + href + '" target="' + target + '"></a>',
            );
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent")
        .delegate("a", "click", function (e) {
            var target = $(this).attr("target"),
                url = $(this).attr("href");

            if (target == "_blank") {
                window.open(url);
            } else {
                window.location = url;
            }
            return false;
        })
        .click(function () {
            var target = $(this).find("a.js-click-item-link").attr("target"),
                url = $(this).find("a.js-click-item-link").attr("href");

            if (target == "_blank") {
                window.open(url);
            } else {
                window.location = url;
            }
            return false;
        });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();

        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if (
                elementTop + offset <= viewPortEnd &&
                elementBottom - offset >= viewPortStart
            ) {
                var delay = $(this).data("animation-delay");
                $(this)
                    .css("transition-delay", delay + "s")
                    .addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $("a:not([data-targetblank=ignore])").each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr("target", "_blank");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-nav-button").click(function () {
        $(this).toggleClass("active");
    });

    $(function () {
        const $navButton = $(".js-nav-button");
        const $navMobile = $(".js-navmobile");
        const $body = $("body");

        if (!$navButton.length || !$navMobile.length) return;

        // Toggle mobile menu overlay
        $navButton.on("click", () => {
            const isCurrentlyOpen = $navMobile.hasClass("active");
            if (!isCurrentlyOpen) {
                $navMobile.addClass("active");
                $body.addClass("freeze");
            } else {
                $navMobile.removeClass("active");
                $body.removeClass("freeze");
                // Reset all submenus when menu is closed
                $(".js-navmobile-inner").removeClass("active");
            }
        });

        // Open submenus (sliding panels) for parent navigation links
        $(".js-navmobile-parent").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $inner = $(this).siblings(".js-navmobile-inner");
            $inner.addClass("active");
        });

        // Open submenu for language wrapper
        const $langButton = $(".navMobile__languageButton");
        if ($langButton.length) {
            $langButton.on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                const $inner = $(this)
                    .closest(".navMobile__languageWrapper")
                    .find(".js-navmobile-inner");
                $inner.addClass("active");
            });
        }

        // Close submenus on back buttons
        $(".navMobile__backbutton").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).closest(".js-navmobile-inner").removeClass("active");
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * language button
    // *
    // *
    $(".js-language-button").click(function () {
        $(this).toggleClass("active");
    });

    $(".js-language-list").on("mouseleave", function () {
        $(".js-language-button").removeClass("active");
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this)
                .find(".js-hero-slider-track")
                .slick({
                    fade: false,
                    infinite: true,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 2500,
                    speed: 1000,
                    waitForAnimate: true,
                    dots: true,
                    pauseOnHover: false,
                    appendDots: $(this).find(".js-hero-slider-dots"),
                    prevArrow: $(this).find(".js-hero-slider-prev"),
                    nextArrow: $(this).find(".js-hero-slider-next"),
                });
            $(this).on(
                "init reInit afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    $(this).find(".js-hero-slider-count").text(i);
                },
            );
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * logoSlider
    // *
    // *
    var $logoSlider = $(".js-logo-slider");

    if ($logoSlider.length) {
        // Constant speed in pixels/second, so the marquee doesn't speed up
        // just because more logos (= a wider track) were added.
        var logoSliderSpeed = 60;

        var setLogoSliderDuration = function () {
            $logoSlider.each(function () {
                var $track = $(this).find(".js-logo-slider-track");
                if ($track.length) {
                    var duration = $track[0].scrollWidth / 2 / logoSliderSpeed;
                    $track.css("animation-duration", duration + "s");
                }
            });
        };

        $logoSlider.each(function () {
            var $track = $(this).find(".js-logo-slider-track");
            if ($track.length) {
                var $slides = $track.children();
                if ($slides.length) {
                    // Duplicate slides to enable seamless 0% to -50% CSS infinite marquee
                    $track.append($slides.clone());
                    if ($track.children().length < 12) {
                        $track.append($track.children().clone());
                    }
                }
            }
        });

        setLogoSliderDuration();
        // Recalculate once images are loaded, since their rendered width
        // (and thus the track width) may not be final at document ready.
        $(window).on("load", setLogoSliderDuration);
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            var $sliderTrack = $(this).find(".js-content-slider-track");
            var $textTrack = $(this).find(".js-content-slider-text-track");

            if ($textTrack.length) {
                $textTrack.slick({
                    asNavFor: $sliderTrack,
                    fade: true,
                    infinite: true,
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    speed: 1000,
                    waitForAnimate: true,
                });
            }

            $sliderTrack.slick({
                asNavFor: $textTrack.length ? $textTrack : null,
                variableWidth: true,
                centerMode: false,
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: false,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on(
                "init reInit afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    var i = (currentSlide ? currentSlide : 0) + 1;
                    $(this).find(".js-content-slider-count").text(i);
                },
            );
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this)
            .parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        // setTimeout(() => {
        //     $(this)[0].scrollIntoView({ behavior: 'smooth' });
        // }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split("#")[1];
        if (
            hash &&
            $("#" + hash).hasClass("js-accordion-button") &&
            $("#" + hash)
                .siblings(".js-accordion-content")
                .attr("aria-expanded") !== "true"
        ) {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on("hashchange", function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter-sticky
    // *
    // *
    $(function () {
        var $filter = $(".js-sticky-filter");
        var $filterEnd = $(".js-sticky-filter-end");

        if (!$filter.length || !$filterEnd.length) return;

        var triggerOffset = 80;
        var filterStartTop = $filter.offset().top;

        function updateStickyState() {
            var scrollTop = $(window).scrollTop();
            var endBottom = $filterEnd.offset().top + $filterEnd.outerHeight();

            var pastStart = scrollTop + triggerOffset >= filterStartTop;
            var pastEnd = scrollTop + triggerOffset >= endBottom;

            if (pastStart && !pastEnd) {
                $filter.addClass("sticky");
            } else {
                $filter.removeClass("sticky");
            }
        }

        $(window).on("scroll", updateStickyState);
        $(window).on("resize", function () {
            filterStartTop = $filter.offset().top;
            updateStickyState();
        });

        // run once on load in case the page loads pre-scrolled
        updateStickyState();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter-accordion
    // *
    // *
    $(".js-filter-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-filter-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this)
            .parents(".js-filter-accordion-wrapper")
            .find(".js-filter-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: "smooth" });
        }, 400);
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter-mobile
    // *
    // *
    $(function () {
        const $filterMobile = $(".js-filter-mobile");
        const $filterMobileCloseButton = $(".js-filter-mobile-close");
        const $filterMobileOpenButton = $(".js-filter-mobile-open");

        const $filterMobileOptions = $(
            ".js-filter-accordion-filter-list button",
        );

        function openFilterMobile() {
            $filterMobile.addClass("active");
        }

        function closeFilterMobile() {
            $filterMobile.removeClass("active");
        }

        $filterMobileOpenButton.on("click", function () {
            openFilterMobile();
        });

        $filterMobileCloseButton.on("click", function () {
            closeFilterMobile();
        });

        $filterMobileOptions.on("click", function () {
            $(this).toggleClass("active");
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem("dialogState");

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem("dialogState", true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem("dialogState", true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hero video
    // *
    // *

    // Anmerkung Stefan: wofür das Skript? Nur für den Live-Wechsel wenn sich die Fenstergröße ändert?

    // var mediaQueryHeroVideo = window.matchMedia("(min-width: 768px)");

    // function updateVideo($video, isDesktop) {
    //     var source = isDesktop
    //         ? $video.find("source[media]")[0]
    //         : $video.find("source:not([media])")[0];

    //     var newSrc = $(source).data("src");

    //     if ($video.attr("data-current-src") === newSrc) {
    //         return;
    //     }

    //     source.src = newSrc;
    //     $video.attr("data-current-src", newSrc);
    //     $video[0].load();

    //     if (!$video[0].paused || $video.prop("autoplay")) {
    //         $video[0].play();
    //     }
    // }

    // function updateAllVideos(e) {
    //     $(".js-hero-video").each(function () {
    //         updateVideo($(this), e.matches);
    //     });
    // }

    // updateAllVideos(mediaQueryHeroVideo);
    // mediaQueryHeroVideo.addEventListener("change", updateAllVideos);

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animations
    // *
    // *
    $(function () {
        var $lineAnimations = $(".js-animate-lines-right-to-left");

        if (!$lineAnimations.length) {
            return;
        }

        var staggerStep = 120; // ms between each line's animation

        $lineAnimations.each(function () {
            var $el = $(this);
            var lines = $el.html().split(/<br\s*\/?>/i);

            var html = "";

            $.each(lines, function (i, line) {
                line = $.trim(line);

                if (line === "") {
                    return;
                }

                html +=
                    '<span class="lineMask">' +
                    '<span class="lineMask__inner">' +
                    line +
                    "</span>" +
                    "</span>";
            });

            $el.html(html);
        });

        if ("IntersectionObserver" in window) {
            var globalIndex = 0;

            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            var $line = $(entry.target).find(
                                ".lineMask__inner",
                            );
                            var delay = globalIndex * staggerStep;
                            globalIndex++;

                            setTimeout(function () {
                                $line.addClass("is-active");
                            }, delay);

                            observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    threshold: 1,
                    rootMargin: "0px 0px -20% 0px",
                },
            );

            $lineAnimations.find(".lineMask").each(function () {
                observer.observe(this);
            });
        } else {
            $lineAnimations.find(".lineMask__inner").addClass("is-active");
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * numbers columns
    // *
    // *
    $(function () {
        const $items = $(".js-animate-item");

        if (!$items.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const $item = $(entry.target);

                        // stagger based on position within its own trigger group
                        const $group = $item.closest(
                            ".js-animate-bottom-to-top",
                        );
                        const index = $group
                            .find(".js-animate-item")
                            .index($item);

                        setTimeout(() => {
                            $item.addClass("is-animated");
                        }, index * 300);

                        observer.unobserve(entry.target); // animate once
                    }
                });
            },
            {
                threshold: 0.2,
            },
        );

        $items.each(function () {
            observer.observe(this);
        });
    });

    $(function () {
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
        // * numbers line
        // *
        // *
        const $lines = $(".js-number-list-line");
        const triggerOffset = 300; // matches .numberList__intro's sticky "top" value

        if (!$lines.length) return;

        let ticking = false;

        function updateLines() {
            const triggerY = triggerOffset;

            $lines.each(function () {
                const $line = $(this);
                const $fill = $line.find(".js-number-list-line-fill");
                const rect = this.getBoundingClientRect();

                const lineTop = rect.top;
                const lineHeight = rect.height;

                // how far the trigger point has moved into the line
                let progress = (triggerY - lineTop) / lineHeight;
                progress = Math.min(Math.max(progress, 0), 1); // clamp 0–1

                $fill.css("height", progress * 100 + "%");
            });

            ticking = false;
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(updateLines);
                ticking = true;
            }
        }

        $(window).on("scroll resize", onScroll);
        updateLines(); // run once on load in case list is already in view
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * partner-views
    // *
    // *
    $(function () {
        const $root = $(".js-partner");
        const $toggleButton = $root.find(".js-button-toggle-partner-view");
        const $dots = $root.find(".js-partner-dot-list");
        const $slider = $root.find(".js-partner-slider-wrapper");

        const $dropdown = $root.find(".js-dropdown");
        const $dropdownButton = $root.find(".js-drodpown-button");
        const $dropdownList = $root.find(".js-drodpown-list");
        const $dropdownLabel = $root.find(".js-dropdown-button-label");
        const $filterButtons = $root.find(".js-partner-filter");
        const $dropdownOptions = $dropdownList.find("button");

        var defaultLabelText = $dropdownLabel.text().trim();

        function showSliderView() {
            $root.addClass("partner--slider-view");
            $toggleButton.addClass("active");
        }

        function showMapView() {
            $root.removeClass("partner--slider-view");
            resetPartnerDropdown();
        }

        $toggleButton.on("click", function () {
            if ($root.hasClass("partner--slider-view")) {
                showMapView();
            } else {
                $root
                    .find('.js-partner-filter[data-filter=""]')
                    .trigger("click");
            }
        });

        $filterButtons.on("click", function () {
            showSliderView();
        });

        function closePartnerDropdown(returnFocus) {
            $dropdown.removeClass("is-open");
            $dropdownButton.attr("aria-expanded", "false");
            if (returnFocus) {
                $dropdownButton.trigger("focus");
            }
        }

        function resetPartnerDropdown() {
            $dropdownOptions.removeClass("is-selected");
            $dropdownLabel.text(defaultLabelText);
            $dropdownLabel.removeClass("not-default-text");
            closePartnerDropdown(false);
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * partner-dots
    // *
    // *
    $(function () {
        const $dots = $(".js-partner-dot");
        let resizeTimer;

        // Set count once — this never changes on resize
        $dots.each(function () {
            const $dot = $(this);
            const count = $dot.find(
                ".js-partner-dot-list > .partnerCard",
            ).length;
            $dot.find(".js-partner-dot-list").addClass(
                "partnerCard__list--" + count,
            );
            $dot.find(".js-partner-dot-count").text(count);
        });

        function updateFlipClasses() {
            const viewportWidth = document.documentElement.clientWidth;

            $dots.each(function () {
                const $dot = $(this);
                const $list = $dot.find(".js-partner-dot-list");

                const dotRect = $dot[0].getBoundingClientRect();
                const listWidth = $list.outerWidth();

                // would the list's right edge overflow the page/viewport itself?
                const wouldOverflow = dotRect.left + listWidth > viewportWidth;

                $dot.toggleClass("partner__dot--flip", wouldOverflow);
            });
        }

        function closeAll() {
            $dots.find(".js-partner-dot-button").removeClass("active");
            $dots.find(".js-partner-dot-list").removeClass("active");
        }

        updateFlipClasses();

        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                closeAll();
                updateFlipClasses();
            }, 150);
        });

        $(".js-partner-dot-button").on("click", function (e) {
            e.stopPropagation();

            const $button = $(this);
            const $dot = $button.closest(".js-partner-dot");
            const $list = $dot.find(".js-partner-dot-list");
            const isActive = $button.hasClass("active");

            $dots
                .not($dot)
                .find(".js-partner-dot-button")
                .removeClass("active");
            $dots.not($dot).find(".js-partner-dot-list").removeClass("active");

            $button.toggleClass("active", !isActive);
            $list.toggleClass("active", !isActive);
        });

        $(document).on("click", function (e) {
            if (!$(e.target).closest(".js-partner-dot").length) {
                closeAll();
            }
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * partnerslider
    // *
    // *
    $(function () {
        const $track = $(".js-partner-slider-track");
        const $filterButtons = $(".js-partner-filter");
        const $dropdownLabel = $(".js-dropdown-label");
        const $dropdown = $(".js-dropdown");

        const $allCards = $track.children(".js-partner-card").clone(true);

        function getSlickSettings(rows) {
            return {
                variableWidth: true,
                slidesToScroll: 1,
                rows: rows,
                infinite: false,
                arrows: true,
                dots: false,
                prevArrow: $(".js-partner-slider-prev"),
                nextArrow: $(".js-partner-slider-next"),
                responsive: [{ breakpoint: 1000, settings: { rows: 1 } }],
            };
        }

        function renderSlider($cards, isFiltered) {
            if ($track.hasClass("slick-initialized")) {
                $track.slick("unslick");
            }

            $track.empty().append($cards.clone(true));

            if ($cards.length) {
                const rows = isFiltered ? 1 : 2;

                requestAnimationFrame(function () {
                    $track.slick(getSlickSettings(rows));
                });
            }

            $track
                .closest(".js-partner-slider")
                .toggleClass("partner-slider--empty", !$cards.length);
        }

        renderSlider($allCards, false);

        $filterButtons.on("click", function () {
            const $button = $(this);
            const filter = $button.data("filter");

            $filterButtons.removeClass("active");
            $button.addClass("active");
            $dropdownLabel.text($button.text());

            const $filtered = filter
                ? $allCards.filter(function () {
                      return $(this).data("filter") === filter;
                  })
                : $allCards;

            renderSlider($filtered, !!filter);

            $dropdown.removeClass("active");
        });

        $(".js-dropdown-toggle").on("click", function (e) {
            e.stopPropagation();
            $dropdown.toggleClass("active");
        });

        $(document).on("click", function (e) {
            if (!$(e.target).closest(".js-dropdown").length) {
                $dropdown.removeClass("active");
            }
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * video-player
    // *
    // *
    $(function () {
        $(".js-video-player").each(function () {
            var $player = $(this);
            var $video = $player.find(".js-video-player-video");
            var $playButton = $player.find(".js-video-player-play-button");
            var $muteButton = $player.find(".js-video-player-mute-button");

            var video = $video.get(0); // natives DOM-Element für play()/pause()/muted

            // ---------- Play / Pause ----------

            $playButton.on("click", function () {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            $video.on("play", function () {
                $playButton.addClass("active");
            });

            $video.on("pause", function () {
                $playButton.removeClass("active");
            });

            $video.on("ended", function () {
                $playButton.removeClass("active");
            });

            // ---------- Mute / Unmute ----------

            $muteButton.on("click", function () {
                video.muted = !video.muted;
            });

            $video.on("click", function () {
                $playButton.trigger("click");
            });
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * toggle-button
    // *
    // *
    $(".js-button-toggle-icon").click(function () {
        $(this).toggleClass("active");
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dropdown
    // *
    // *
    $(".js-dropdown").each(function () {
        var $dropdown = $(this);
        var $button = $dropdown.find(".js-drodpown-button");
        var $listWrapper = $dropdown.find(".js-drodpown-list");
        var $label = $dropdown.find(".js-dropdown-button-label");
        var $options = $listWrapper.find("button");

        var isMultiSelect = $dropdown.attr("data-multiselect") === "true";

        function openDropdown() {
            // close any other open dropdowns first
            $(".js-dropdown.is-open")
                .not($dropdown)
                .each(function () {
                    $(this)
                        .removeClass("is-open")
                        .find(".js-drodpown-button")
                        .attr("aria-expanded", "false");
                });

            $dropdown.addClass("is-open");
            $button.attr("aria-expanded", "true");
            $options.first().trigger("focus");
        }

        function closeDropdown(returnFocus) {
            $dropdown.removeClass("is-open");
            $button.attr("aria-expanded", "false");
            if (returnFocus) {
                $button.trigger("focus");
            }
        }

        function isOpen() {
            return $dropdown.hasClass("is-open");
        }

        // toggle on button click
        $button.on("click", function (e) {
            e.stopPropagation();
            isOpen() ? closeDropdown(false) : openDropdown();
        });

        // select an option (in deinem bestehenden Code)
        $options.on("click", function () {
            if (isMultiSelect) {
                $(this).toggleClass("is-selected");
                $(this).attr("aria-selected", $(this).hasClass("is-selected"));
            } else {
                var label = $(this).text().trim();
                $options.removeClass("is-selected");
                $(this).addClass("is-selected");
                $label.text(label);
                $label.addClass("not-default-text");
                closeDropdown(true);
            }
        });

        function triggerProjectAJAX() {
            var $projectContent = $(".js-project-content");
            var searchParams = new URLSearchParams();

            // Multiselect-Filter einsammeln
            $(
                '.js-dropdown[data-multiselect="true"] .js-filter-btn.is-selected',
            ).each(function () {
                var filterName = $(this).data("filter");
                var filterValue = $(this).data("value");

                if (searchParams.has(filterName)) {
                    searchParams.set(
                        filterName,
                        searchParams.get(filterName) + "," + filterValue,
                    );
                } else {
                    searchParams.set(filterName, filterValue);
                }
            });

            // Sortierung einsammeln
            var sortVal = $(".js-shop-sort.is-selected").data("sort");
            if (sortVal) {
                searchParams.set("sort", sortVal);
            }

            // URL zusammenbauen
            var urlObj = new URL(window.location.href);
            urlObj.search = searchParams.toString();
            var newUrl = urlObj.toString();

            // Falls du einen js-spinner hast, hier einblenden: $('.js-spinner').addClass('active');

            $.get(newUrl)
                .done(function (data) {
                    $projectContent.html(
                        $(data).find(".js-project-content").html(),
                    );
                    window.history.pushState({}, "", newUrl);
                })
                .always(function () {
                    // $('.js-spinner').removeClass('active');
                });
        }

        // close on outside click
        $(document).on("click", function (e) {
            if (isOpen() && !$(e.target).closest(".js-dropdown").length) {
                closeDropdown(false);
            }
        });

        // close on Escape
        $(document).on("keydown", function (e) {
            if (e.key === "Escape" && isOpen()) {
                closeDropdown(true);
            }
        });

        // basic arrow-key navigation within the list
        $options.on("keydown", function (e) {
            var $items = $options;
            var index = $items.index(this);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                $items.eq((index + 1) % $items.length).trigger("focus");
            }
            if (e.key === "ArrowUp") {
                e.preventDefault();
                $items
                    .eq((index - 1 + $items.length) % $items.length)
                    .trigger("focus");
            }
        });
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * shelf animation
    // *
    // *
    $(function () {
        var elements = document.querySelectorAll(".js-animate-shelf-element");
        if (!elements.length) return;

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.2,
                rootMargin: "0px 0px -10% 0px",
            },
        );

        elements.forEach(function (el) {
            observer.observe(el);
        });
    });

    // $(document).on('click', '.theme-light, .theme-dark', function (e) {
    //     var $el = $(this);
    //     var isLight = $el.hasClass('theme-light');

    //     $el
    //         .toggleClass('theme-light', !isLight)
    //         .toggleClass('theme-dark', isLight);
    // });
});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});

$(function () {
    // Filter-/Sort-Klick
    $(document).on("click", ".js-filter-btn", function () {
        var $btn = $(this);

        // aktuelle URL als Basis (behält vorhandene Filter + Hash)
        var urlObj = new URL(window.location.href, window.location.origin);

        // Filter (Area / Industry / Country)
        var filterName = $btn.data("filter");
        if (filterName) {
            var filterValue = $btn.data("value");
            if (filterValue === "" || filterValue == null) {
                urlObj.searchParams.delete(filterName); // "All ..." -> Filter entfernen
            } else {
                urlObj.searchParams.set(filterName, filterValue);
            }
            urlObj.searchParams.delete("ppage"); // bei Filterwechsel zurück auf Seite 1
        }

        // Sortierung
        var sortVal = $btn.data("sort");
        if (sortVal) {
            urlObj.searchParams.set("sort", sortVal);
        }

        triggerProjectAJAX(urlObj.toString());
    });

    // Pagination-Klick
    $(document).on("click", ".js-ajax-pagination", function (e) {
        e.preventDefault();
        triggerProjectAJAX($(this).attr("href"));
    });

    function triggerProjectAJAX(newUrl) {
        var $projectContent = $(".js-project-content");

        $.get(newUrl).done(function (data) {
            var newContent = $(data).find(".js-project-content").html();
            $projectContent.html(newContent);

            var newProjects = $projectContent
                .find("#ajax-counter-data")
                .data("projects");
            var newCountries = $projectContent
                .find("#ajax-counter-data")
                .data("countries");
            $(".js-count-projects").text(newProjects);
            $(".js-count-countries").text(newCountries);

            window.history.pushState({}, "", newUrl);
        });
    }
});
